import PageLayout from "components/layout/PageLayout"
import durationToDays from "../../../utility/SecondToDays"
import { useGetUsersQuery } from "../users/usersApiSlice";
import { useGetLicenseInfoQuery } from "./api/licenseApiSlice"
import { Knob } from 'primereact/knob';

const LicenseInfo = () => {

    const {
        data: licenseInfo,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetLicenseInfoQuery()

    const {
        data: users,
        isSuccess: usersIsSuccess,
    } = useGetUsersQuery()

    let durationLeft
    let durationTotal
    let durationPerc

    let activeUsers
    let maxUsers
    let userCapacityPerc

    if (isSuccess && usersIsSuccess) {
        durationLeft = durationToDays(new Date(), licenseInfo.claims.exp * 1000)
        durationTotal = durationToDays(licenseInfo.claims.iat * 1000, licenseInfo.claims.exp * 1000)
        durationPerc = Math.round((durationLeft / durationTotal) * 100)

        activeUsers = users.length
        maxUsers = licenseInfo.claims.maxUsers
        userCapacityPerc = Math.round((activeUsers / maxUsers) * 100)
    }

    const getKnobColor = (value) => {
        if (value > 75) {
            return "#2bb673"
        } else if (value >= 50) {
            return "green"
        } else if (value > 20) {
            return "orange"
        } else return "red"
    }


    let content;
    if (isSuccess) {

        const statusView = () => {
            switch (licenseInfo.status) {
                case "VALID": return <span className="badge bg-success"> <i className="fa-solid fa-circle-check"></i>  Valid </span>
                case "EXPIRED": return <span className="badge bg-warning"> <i className="fa-regular fa-circle-xmark"></i>  Expired </span>
                default: return <span className="badge bg-danger"> <i className="fa-solid fa-circle-check"></i>  Invalid </span>
            }
        }

        content = (
            <div>
                <div className="row">
                    <p className="d-inline-flex gap-1">
                        <button className="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                            <i className="fa-solid fa-eye"></i>  License Key
                        </button>
                    </p>
                    <div className="collapse" id="collapseExample">
                        <div className="card card-body">
                            {licenseInfo.licenseKey}
                        </div>
                    </div>
                </div>
                <div className={`card bg-black bg-opacity-10 mb-4`}>
                    <div className="card-header">
                        <i className="fa-solid fa-circle-exclamation"></i> Info
                    </div>

                    <div className="card-body p-4">
                        <div className="row">
                            <div className="col-sm-6">
                                <table className="table table-hover ">

                                    <tbody className=" ">
                                        <tr>
                                            <th scope="row"  >Status</th>
                                            <td >
                                                <h6>{statusView()}</h6>
                                            </td>
                                        </tr>
                                        {
                                            licenseInfo.claims && usersIsSuccess &&
                                            <>
                                                <tr>
                                                    <th scope="row">Creation</th>
                                                    <td>{new Date(licenseInfo.claims.iat * 1000).toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Expiration</th>
                                                    <td>{new Date(licenseInfo.claims.exp * 1000).toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Users</th>
                                                    <td>{licenseInfo.claims.maxUsers}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Modules</th>
                                                    <td>
                                                        {
                                                            licenseInfo.claims.modules.map(module => {
                                                                return <><span className="badge bg-dark">{module}</span><br /></>
                                                            })

                                                        }

                                                    </td>
                                                </tr>
                                            </>
                                        }

                                    </tbody>
                                </table>
                            </div>
                            {
                                usersIsSuccess &&
                                <>
                                    <div className="col-sm-3 p-2 text-center">

                                        <h4><i className="fa-solid fa-clock"></i> Duration</h4>
                                        <br />
                                        <Knob
                                            value={durationPerc}
                                            valueTemplate={`${durationLeft}`}
                                            valueColor={getKnobColor(durationPerc)}
                                            strokeWidth={8}
                                        />
                                        <span >days remaining</span><br />
                                        <span className="text-muted" >{`of ${durationTotal} days `}</span>


                                    </div>
                                    <div className="col-sm-3 p-2 text-center">
                                        <h4><i className="fa-solid fa-users"></i> Capacity</h4>
                                        <br />
                                        <Knob
                                            value={userCapacityPerc}
                                            valueTemplate={`${userCapacityPerc}%`}
                                            valueColor="white"
                                            strokeWidth={8}
                                        />
                                        <span >{activeUsers} enrolled accounts</span><br />
                                        <span className="text-muted" >{`of ${maxUsers} available`}</span>
                                    </div>
                                </>

                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (isError) {
        content = <p>{JSON.stringify(error)}</p>;
    }


    return <PageLayout
        pageTitle={"License"}
        onPageRefresh={refetch}
        isLoadingContent={isFetching}
        bodyContent={content}
    />

}

export default LicenseInfo